import React from 'react';
import Link from 'compat/Link';
import Container from 'common/components/UI/Container';
import Heading from 'common/components/Heading';
import NextImage from 'common/components/NextImage';
import Text from 'common/components/Text';

import FooterWrapper, {
  FooterInner,
  CopyrightInfo,
  FooterWidget,
  Nav,
} from './footer.style';

import { footerWidget } from 'common/data/AppCreative';

import { fontSize } from 'styled-system';

const Footer = () => {
  return (
    <FooterWrapper>
      <Container>
        <FooterInner>
          <CopyrightInfo>
            <NextImage src={footerWidget.logo} alt="Logo" width={200}/>
            <p>
              © {new Date().getFullYear()} Linok™
            </p>
            <Text className="copyright" content="All rights reserved." />
            {/* <Nav className="social__share">
              {footerWidget.socialLinks.map((item) => (
                <Link key={item.id} href={item.link} className={item.name}>
                  {item.icon}
                </Link>
              ))}
            </Nav> */}
          </CopyrightInfo>

          <FooterWidget>
            <Heading as="h4" content={footerWidget.navigation.title} />
            <Nav>
              {footerWidget.navigation.menuItems.map((item) => (
                <Link key={item.id} href={item.url}>
                  {item.text}
                </Link>
              ))}
            </Nav>
          </FooterWidget>

          <FooterWidget>
            <Heading as="h4" content={footerWidget.ourInformation.title} />
            <Nav>
              {footerWidget.ourInformation.menuItems.map((item) => (
                <Link key={item.id} href={item.url}>
                  {item.text}
                </Link>
              ))}
            </Nav>
          </FooterWidget>

          <FooterWidget>
            <Heading as="h4" content={footerWidget.ourContacts.title} />
            <Nav>
              {footerWidget.ourContacts.menuItems.map((item) => (
                // <Text style={{fontSize:14}} key={item.id} content={item.text}/>

                <Link key={item.id} href={item.link}>
                {item.text}
              </Link>
              ))}
            </Nav>
          </FooterWidget>
        </FooterInner>
      </Container>
    </FooterWrapper>
  );
};

export default Footer;
